import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ToastrService } from 'ngx-toastr';
import { ItemNumberApiService } from 'src/app/core/api/item-number-api.service';

@Component({
  selector: 'app-item-number-actions',
  standalone: true,
  imports: [],
  templateUrl: './actions.component.html',
  styleUrl: './actions.component.scss'
})
export class ActionsComponent implements ICellRendererAngularComp {
   private params: ICellRendererParams;

   constructor(
        private itemNumberApiService: ItemNumberApiService,
        private translateService: TranslateService,
        private toastrService: ToastrService
    ) {}

  agInit(params: ICellRendererParams): void {
   this.params = params;
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  onDeleteRow(): void {
    const rowData = this.params.node.data;

    this.itemNumberApiService.delete(rowData.id).subscribe({
        next: () => {
            this.params.api.applyTransaction({ remove: [rowData] });
            const message = this.translateService.instant("itemNumbers.form.delete");
            this.toastrService.success(message);
        },
        error: () => {
            const message = this.translateService.instant("itemNumbers.form.deleteError");
            this.toastrService.error(message);
        }
    });
  }
}
